export default __webpack_public_path__ + "zoom-out.0c1ea89a2f516aaf.svg";